// extracted by mini-css-extract-plugin
export default {"label":"Label_label__IhmyK","hover":"Label_hover__8kX8z"};